import { render, staticRenderFns } from "./InspectionModal.vue?vue&type=template&id=bd1f1020"
import script from "./InspectionModal.vue?vue&type=script&lang=js"
export * from "./InspectionModal.vue?vue&type=script&lang=js"
import style0 from "./InspectionModal.vue?vue&type=style&index=0&id=bd1f1020&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports